export default function PawR() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 337 311">
      <path
        fill="#BFE4C8"
        fillRule="evenodd"
        d="M290.532 71.99c-20.454-5.467-35.466.956-47.382 12.783-17.026 16.902-34.77 28.179-57.299 36.475-35.129 12.916-45.027 49.76-21.08 78.464 15.358 18.405 25.056 37.03 31.34 60.149 4.39 16.185 14.173 29.234 34.626 34.7 41.175 11.004 78.318-20.9 79.246-59.288.632-26.532 6.703-49.128 19.456-72.42 18.441-33.707 2.267-79.86-38.907-90.864Z"
        clipRule="evenodd"
      />
      <path
        fill="#BFE4C8"
        d="M233.339 29.255C215.196 1.481 187.19-6.223 148.894 6.895l17.512 58.351c3.024 11.424 10.776 19.006 21.918 22.604 35.171 11.392 65.195-27.69 45.015-58.595ZM159.783 303.05c-29.636 15.006-57.752 7.712-84.338-22.758l44.416-41.793c8.346-8.385 18.86-11.082 30.316-8.654 36.167 7.686 42.575 56.505 9.606 73.205ZM122.866 52.293C88.716 33.819 56.178 39.797 25.29 71.188l51.092 48.785c9.597 9.741 21.72 13.446 34.978 11.585 41.835-5.838 49.515-58.699 11.506-79.265ZM.626 162.993c11.013 42.588 36.196 63.992 75.032 65.023 43.229 1.131 63.075-48.466 29.771-74.383-10.548-8.224-22.905-11.061-36.1-7.411l.005-.012L.626 162.993Z"
      />
    </svg>
  );
}
